import * as React from "react";
import {cx}       from "emotion";

import "./blank-canvas-product.scss";

import {ComponentLink,
        Link,
        makeChain}      from "@Common/react/cst2";

import {LoadingSpinner} from "../components/loading-spinner";
import {SelectionTile}  from "../components/selection-tile";


export const BlankCanvasProduct = ({
    products
}:{
    products : any[]
}) => (

    makeChain<JSX.Element>()

    // render view
    .then(({}) => (
        <div className="blank-canvas-product-ps6">
            {!products ? (
                <LoadingSpinner text="Loading Products"/>
            ) : products.length == 0 ? (
                <div className="no-products" xd-qa-type="label" xd-qa-name="Empty">
                    No products are available!
                </div>
            ) : Object.entries(products).map(([productId, product]) => product.child.map(layout => (
                <SelectionTile
                    key={productId+"-"+layout.id}
                    text={layout.name}
                    image={layout.image}
                    onClick={() => window.location.hash = `#new-template-layout-${layout.name}-${productId}-${layout.id}`}
                />
            )))}
        </div>
    ))

    .run()

);
